import { CommentItem } from 'stores/DocStore.types'
import Avatar from 'common/Avatar/Avatar'
import { useAuth } from 'hooks/UseAuth'
import { getInitials } from 'utils'
import Styles from 'components/CollabItemInlineWidget/TrackedChangeItemSummary.module.scss'

interface Props {
  collabItem: CommentItem
  isActive: boolean
}

export const CommentItemSummary = ({ collabItem, isActive }: Props) => {
  const auth = useAuth()
  const {
    item: { user },
  } = collabItem

  const byMe = auth && user?.id === auth.id
  const userName = user?.display_name || 'Anonymous'

  return (
    <div className={Styles.avatar}>
      <Avatar url={user.avatar_url} label={byMe ? 'You' : getInitials(userName)} size={isActive ? 20 : 24} />
    </div>
  )
}
